import { Instance, types } from "mobx-state-tree";
import { AnyUserReferenceType } from "../../../users/AnyUserReferenceType";
import { ChatItemType } from "../ChatItemType";
import { TextChatItem } from "./TextChatItem";

export const NoteChatItem = types.compose(
  "NoteChatItem",
  TextChatItem,
  types.model({
    type: types.literal(ChatItemType.Note),
    user: AnyUserReferenceType
  })
);

export interface INoteChatItem extends Instance<typeof NoteChatItem> {}
